import EN from 'assets/images/flags/us.svg';
import ES from 'assets/images/flags/es.svg';
import PT from 'assets/images/flags/pt.svg';
import MX from 'assets/images/flags/mx.svg';
import AR from 'assets/images/flags/ar.svg';
import CO from 'assets/images/flags/co.svg';
import CL from 'assets/images/flags/cl.svg';
import BR from 'assets/images/flags/br.svg';
import PE from 'assets/images/flags/pe.svg';

const langs = {
  EN,
  ES,
  PT,
  PE,
  CL,
  CO,
  AR,
  MX,
  BR
};

export default langs;
